import { gql } from '@apollo/client';

export const GET_PACKAGE = gql`
  query GetPackage($id: Int!) {
    package(id: $id) {
      id
      title
      description
      image
      groupSize
      category
      type
      departure
      departures {
        id
        departureDate
        returnDate
      }
      highlights
      included
      excluded
      cities
      countries
      agency {
        id
        name
      }
      formulas {
        id
        name
        priceType
        perPersonPrice
        roomPrices {
          single
          double
          triple
          quadruple
          quintuple
        }
        discountPercent
        services
        hotels {
          id
          name
          stars
          image
          address
          amenities
          meals
          bookingUrl
        }
      }
      itinerary {
        id
        dayNumber
        title
        description
        activities
        meals {
          breakfast
          lunch
          dinner
        }
        accommodation
      }
      commission
      programPdf
      airlineId
      airline {
        id
        name
        code
        logo
      }
      bookings {
        id
      }
    }
  }
`;

export const GET_AGENCY_PACKAGES = gql`
  query GetAgencyPackages($agencyName: String!) {
    agencyPackages(agencyName: $agencyName) {
      id
      title
      image
      description
      groupSize
      category
      departure
      type
      departures {
        id
        departureDate
        returnDate
      }
    }
  }
`;

export const GET_ALL_PACKAGES = gql`
  query GetAllPackages {
    packages {
      id
      title
      image
      description
      groupSize
      category
      departure
      type
      agency {
        id
        name
      }
      formulas {
        id
        name
        priceType
        perPersonPrice
        roomPrices {
          single
          double
          triple
          quadruple
          quintuple
        }
      }
      departures {
        id
        departureDate
        returnDate
      }
    }
  }
`; 